/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharechannelqr2Inputs */

const en_sharechannelqr2 = /** @type {(inputs: Sharechannelqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poster (QR code)`)
};

const de_sharechannelqr2 = /** @type {(inputs: Sharechannelqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plakat (QR-Code)`)
};

/**
* | output |
* | --- |
* | "Poster (QR code)" |
*
* @param {Sharechannelqr2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharechannelqr2 = /** @type {((inputs?: Sharechannelqr2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharechannelqr2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharechannelqr2(inputs)
	return de_sharechannelqr2(inputs)
});
export { sharechannelqr2 as "shareChannelQr" }